import React from 'react';
import withEnterToClick from '~app/core/withEnterToClick';

const ClickOrEnterDiv = withEnterToClick('div');

// Landing page
// Open model, Creation tool and Grading tool buttons
const ButtonBox = ({
  buttons,
  title,
  description,
  descriptionStyle,
  bottomText,
  padded,
}) => {
  return (
    <div className="ButtonBox__box">
      <h2>{title}</h2>
      {description && (
        <div className={`ButtonBox__description ${descriptionStyle}`}>
          {description}
        </div>
      )}
      <div className="ButtonBox__button-container">
        {buttons.map(button => (
          <ClickOrEnterDiv
            key={button.name ?? button.text}
            className={
              padded
                ? 'ButtonBox__button ButtonBox__button-padded'
                : 'ButtonBox__button'
            }
            onClick={button.onClick}
            role="button"
            aria-label={button.text}
            tabIndex="0"
          >
            {button.text}
          </ClickOrEnterDiv>
        ))}
      </div>
      {bottomText && (
        <div
          id="ButtonBox-description-dynamic"
          className="ButtonBox__description-dynamic"
        >
          {bottomText}
        </div>
      )}
      {bottomText && (
        <div
          id="ButtonBox-description-dynamic-sr"
          class="visually-hidden"
          aria-live="polite"
        ></div>
      )}
    </div>
  );
};

export default ButtonBox;
